var SENTRY_RELEASE;SENTRY_RELEASE={name: "HiNote Life TV Master", version: "4.0.2"};